module.exports = __webpack_public_path__ + "media/assets/img/pages/reset-password-01a139f9cdd57337bcf899cc08d032ac.png";